import { render, staticRenderFns } from "./SubsidyConfiguration.vue?vue&type=template&id=50ac6988"
import script from "./SubsidyConfiguration.vue?vue&type=script&lang=ts"
export * from "./SubsidyConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./SubsidyConfiguration.vue?vue&type=style&index=0&id=50ac6988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports